export enum TrainingState {
  SignedUp = 1,
  UnderMinimum = 2,
  Available = 3,
  Maximum = 4,
}

export type TrainingStateUnion = keyof typeof TrainingState;
